@if ((noShell$ | async) === false) {
    <div class="main-wrapper" [attr.aria-hidden]="trayOpened$ | async">
        <h-notification-modal></h-notification-modal>
        @if ((isFull$ | async) === true && (footerOnly$ | async) === false) {
            <h-header class="header"></h-header>
        }
        @if ((isLight$ | async) === true && (footerOnly$ | async) === false) {
            <h-header-light class="header" [displayBackToHome]="isBackButtonHome"></h-header-light>
        }
        <main id="main" class="main-element" [attr.role]="'main'">
            <ng-container [ngTemplateOutlet]="transcludedContent"></ng-container>
        </main>
        @if ((isFull$ | async) === true && (isNewFooterActivateFF$ | async) === false) {
            <h-footer-deprecated></h-footer-deprecated>
        }
        @if ((isLight$ | async) === true) {
            <h-footer-light></h-footer-light>
        }
        @if ((isNewFooterActivateFF$ | async) === true && (isFull$ | async) === true) {
            <h-footer></h-footer>
            <h-parallax-logo />
        }
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="transcludedContent" />
}
<ng-template #transcludedContent>
    <div id="content" class="content-wrapper">
        <ng-content></ng-content>
    </div>
</ng-template>
